export default "__VITE_ASSET__zPiR4mH2__"